import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserService } from '@app-services/user/user.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { ClassModel } from 'src/app/model/class';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';

@Component({
  selector: 'app-teacher-class-card-list',
  templateUrl: './teacher-class-card-list.component.html',
  styleUrls: ['./teacher-class-card-list.component.css']
})
export class TeacherClassCardListComponent implements OnInit {
  @Input() classData : ClassModel | any;
  @Input() type: any;
  @Input() dataType: any;
  @Input() isMySchedule: boolean = true;
  @Input() isShownProfileImg: boolean = false;
  @Input() isClassListingPage: boolean = true;


  private cronScheduleJob: any = null;
  showJoinNow: any;
  public isClassLive: boolean = false;
  public isStatusLive: boolean = false;
  public isPastSchedule: boolean = false;
  public isTodaySchedule: boolean = false;
  public isUpcomingSchedule: boolean = false;
  public isTomorrowSchedule: boolean = false;
  public scheduleWaitingDays: number = 0;
  public isMeetingAttended: boolean = false;
  public crntUser: any = null;
  private viewerDialog: any = null;
  public isMyCoursePage: boolean = false;

  constructor(
    public router: Router,
    private userService: UserService,
    public _helper: HelperService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.statusCheck();
  }

  previewDocument = (_item: any) => {
    const config: MatDialogConfig = {
      data: {
        item: _item,
        isDocuments: true,
        isDownloadable: true
      },
      disableClose: true,
      scrollStrategy: new NoopScrollStrategy(),
      panelClass: 'doc-viewer-popup'
    };

    this.viewerDialog = this.dialog.open(DocumentViewerComponent, config);

    this.viewerDialog.afterOpened().subscribe(()=>{
      document.body.classList.add('modal-open');
    });

    this.viewerDialog.afterClosed().subscribe((res: any) => {
      document.body.classList.remove('modal-open');
    })
  }

  statusCheck() {
    this.isMyCoursePage = this.router.url.split("/").includes('mycourse') ? true : false;
    this.crntUser = this.userService.getMobileAndName();

    this.type = UtilityService.classType(this.classData.serverTime,this.classData.scheduleTimeStamp.startDate, this.classData.scheduleTimeStamp.endDate, this.classData.meetingStatus);
    if(this.type == 'past') {
      this.isTodaySchedule = false;
      this.isTomorrowSchedule = false;
      this.isPastSchedule = true;
      this.isUpcomingSchedule = false;
      this.isMeetingAttended = this.classData.meetingStatus == "waiting" ? false : true;
    } else {
      this.isTodaySchedule = UtilityService.isToday(this.classData.schedule.startDate, this.classData.schedule.serverTime);
      this.isTomorrowSchedule = UtilityService.isTomorrow(this.classData.schedule.startDate, this.classData.schedule.serverTime);
      this.scheduleWaitingDays = UtilityService.getWaitingDays(this.classData.schedule.startDate, this.classData.schedule.serverTime);
      this.isPastSchedule = false;
      this.isUpcomingSchedule = UtilityService.isUpcomming(this.classData.schedule.startDate, this.classData.schedule.serverTime);
    }
    this.scheduleWaitingDays = UtilityService.getWaitingDays(this.classData.schedule.startDate, this.classData.schedule.serverTime);
    console.group("check class status")
    console.log("classData", this.classData)
    console.log("isTodaySchedule", this.isTodaySchedule)
    console.log("isTomorrowSchedule", this.isTomorrowSchedule)
    console.log("scheduleWaitingDays", this.scheduleWaitingDays)
    console.log("isPastSchedule", this.isPastSchedule)
    console.log("isUpcomingSchedule", this.isUpcomingSchedule)
    console.groupEnd()
    if(this.isTodaySchedule) {
      this.cronScheduleJob = UtilityService.liveClassCounter(this.classData.serverTime, this.classData?.obj?.startTime, this.classData?.obj?.endTime, 'teacher');

      let liveat: any;
      if (this.cronScheduleJob?.ediff >= 0) {

        liveat = setTimeout(() => {
          this.isClassLive = true;
        }, this.cronScheduleJob?.sdiff);

        let livetill = setTimeout(() => {
          this.isClassLive = false;
          clearTimeout(livetill);
          clearTimeout(liveat);
        }, this.cronScheduleJob?.ediff);

      } else if (this.cronScheduleJob?.sdiff <= 0 && this.cronScheduleJob?.ediff >= 0) {
        this.isClassLive = true;
      } else if (this.cronScheduleJob?.ediff == 0) {
        this.isClassLive = false;

      }
    }
    this.checkLiveStatus()
  }

  checkLiveStatus = () => {

    if(this.isTodaySchedule) {
      this.cronScheduleJob = UtilityService.liveClassCounter(this.classData.serverTime, this.classData?.obj?.startTime, this.classData?.obj?.endTime,'joinTeacher');

      let liveat: any;
      if (this.cronScheduleJob?.ediff >= 0) {
      
        setTimeout(() => {
          this.showJoinNow = true;
        }, this.cronScheduleJob?.joinTeacher);

        liveat = setTimeout(() => {
          this.isStatusLive = true;
        }, this.cronScheduleJob?.sdiff);

        let livetill = setTimeout(() => {
          this.isStatusLive = false;
          this.showJoinNow = false;
          clearTimeout(livetill);
          clearTimeout(liveat);
        }, this.cronScheduleJob?.ediff);

      } else if (this.cronScheduleJob?.sdiff <= 0 && this.cronScheduleJob?.ediff >= 0) {
        this.isStatusLive = true;
        this.showJoinNow = true;
      } else if (this.cronScheduleJob?.ediff == 0) {
        this.isStatusLive = false;
        this.showJoinNow = false;
      }
    }
  }

  getClassStatusText():any{
    if(this.isTodaySchedule && !this.isStatusLive) {
      return 'Today';
    } else if (this.isTodaySchedule && this.isStatusLive) {
      return 'NOW LIVE';
    } else if (this.isUpcomingSchedule && this.isTomorrowSchedule) {
      return 'Tomorrow';
    // } else if (this.isUpcomingSchedule && !this.isTomorrowSchedule) {
    //   return 'Starts in ' + this.scheduleWaitingDays + ' days';
    } else if (this.isPastSchedule && this.isMeetingAttended && this.classData.recording.length == 0) {
      return 'Completed';
    } else if (this.isPastSchedule && this.isMeetingAttended && this.classData.recording.length > 0) {
      return 'Recorded';
    } else if (this.isPastSchedule && !this.isMeetingAttended) {
      return 'You missed this class';
    }
  }

}
